// extracted by mini-css-extract-plugin
export default {"squirrelEmbedWrapper":"SquirrelEmbed_squirrelEmbedWrapper__4GtIF"};